// extracted by mini-css-extract-plugin
export default {"cardsContainer":"Courses_cardsContainer__+fDeS"};